import type { SelectedTarget } from '../../../reducers'

export const isSameSelectedDay = ({
  selected,
  targetType
}: {
  selected: SelectedTarget
  targetType: SelectedTarget
}) => {
  return (
    selected?.data?.day === targetType?.data?.day &&
    selected?.data?.teamId === targetType?.data?.teamId
  )
}

export const isSameSelectedContract = ({
  selected,
  targetType
}: {
  selected: SelectedTarget
  targetType: SelectedTarget
}) => {
  return (
    selected?.data?.contractId === targetType?.data?.contractId &&
    selected?.data?.teamId === targetType?.data?.teamId
  )
}
